export const getPropName = <T>(prop: keyof T, idx: number = 0): string => `sessions[${idx}].${String(prop)}`;
